const ProvenResult = () => {
  return (
    <div className="h-full p-4 sm:p-6 py-12 sm:py-16 lg:py-20 bg-[#FAFAFA]">
      <div className="max-w-[95vw] sm:max-w-[90vw] xl:max-w-[85vw] mx-auto">
        <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between space-y-6 xl:space-y-0 xl:space-x-8 h-auto xl:h-[606px] bg-[#DFEDF2] rounded-[12px] p-4 sm:p-6 lg:p-8 xl:p-10">
          {/* Left Content */}
          <div className="flex flex-col items-start w-full xl:w-auto">
            <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-[36px] leading-tight text-hColor w-full sm:max-w-[400px] lg:max-w-[500px] xl:w-[353px]">
              Proven Results, Maximum Efficiency
            </h1>
            <p className="text-pColor text-sm sm:text-base lg:text-lg xl:text-[20px] mt-4 sm:mt-6 lg:mt-8 w-full sm:max-w-[450px] lg:max-w-[550px] xl:w-[503px]">
              Fleet Pro keeps your business running smoothly with
              industry-leading uptime and smart cost-saving solutions.
            </p>
          </div>

          {/* Right Content - Stats Cards */}
          <div className="flex flex-col sm:flex-row xl:flex-row gap-4 sm:gap-6 lg:gap-8 xl:gap-10 w-full xl:w-auto">
            {/* System Uptime Card */}
            <div className="w-full sm:w-1/2 xl:w-[360px] p-4 sm:p-5 lg:p-6 rounded-[12px] border border-[#CECECE] flex flex-col justify-between h-[280px] sm:h-[320px] lg:h-[380px] xl:h-[432px] bg-white">
              <div className="w-full">
                <p className="text-sm sm:text-base lg:text-lg xl:text-[19px] text-[#535353]">
                  Uninterrupted access to your fleet data anytime, anywhere.
                </p>
              </div>
              <div className="w-full space-y-2">
                <div className="bg-[#CECECE] h-[1px] w-full"></div>
                <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-[50px] text-hColor">
                  99.9%
                </h1>
                <p className="text-base sm:text-lg lg:text-xl xl:text-[20px] text-[#535353]">
                  System Uptime
                </p>
              </div>
            </div>

            {/* Savings Card */}
            <div className="w-full sm:w-1/2 xl:w-[360px] p-4 sm:p-5 lg:p-6 rounded-[12px] border border-[#CECECE] flex flex-col justify-between h-[280px] sm:h-[320px] lg:h-[380px] xl:h-[432px] bg-white">
              <div className="w-full">
                <p className="text-sm sm:text-base lg:text-lg xl:text-[19px] text-[#535353]">
                  Reduce expenses with optimized routes and fuel tracking.
                </p>
              </div>
              <div className="w-full space-y-2">
                <div className="bg-[#CECECE] h-[1px] w-full"></div>
                <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-[50px] text-hColor">
                  30%
                </h1>
                <p className="text-base sm:text-lg lg:text-xl xl:text-[20px] text-[#535353]">
                  Savings on Fleet Operations
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProvenResult;
